import { FontSize, PixelUnit } from '../annotations/types';

const isFontSizeInPixelUnits = (fontSize: FontSize): fontSize is PixelUnit =>
  typeof fontSize === 'string' && fontSize.endsWith('px');

export default isFontSizeInPixelUnits;
